import React, { useState } from "react";
import PropTypes from "prop-types";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import classnames from "classnames";
import styles from "./expandable.css";

function Expandable({ chevronClass, children, className, onClick, renderLabel }) {
    const [open, setOpen] = useState(false);
    function toggleOpen() {
        setOpen(!open);
        // For owning components to fire analytics etc.
        if (onClick) {
            onClick(open);
        }
    }
    return (
        <div className={classnames(className, `${open ? styles.open : styles.closed}`)}>
            <div className={styles.button} onClick={toggleOpen}>
                {renderLabel(open)}
                <SVGIcon className={chevronClass} name="round-chevron" rotate={open ? -90 : 90} />
            </div>
            <div className={styles.content}>{children}</div>
        </div>
    );
}

export default Expandable;

Expandable.propTypes = {
    chevronClass: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    renderLabel: PropTypes.func.isRequired,
};
